import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "57",
  height: "57",
  viewBox: "0 0 57 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "Group 1438" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M57 0H0V57H57V0Z",
    fill: "#4A70B3"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector_2",
    d: "M46.8632 13.9448C41.7891 8.87062 33.5682 8.87062 28.4941 13.9448C23.4199 8.87062 15.1991 8.87062 10.1249 13.9448C5.0508 19.0189 5.0508 27.2397 10.1249 32.3023L28.4825 50.6598L46.84 32.3023C51.9141 27.2281 51.9141 19.0073 46.84 13.9448",
    fill: "#4B291D"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector_3",
    d: "M44.1701 16.6386L44.5068 16.3019C42.6258 14.4209 40.141 13.4688 37.6794 13.4688C35.2178 13.4688 32.7329 14.4093 30.8519 16.3019L28.5064 18.6474L26.1609 16.3019C24.2799 14.4209 21.795 13.4688 19.3334 13.4688C16.8718 13.4688 14.3871 14.4093 12.506 16.3019C10.625 18.1829 9.67285 20.6678 9.67285 23.1294C9.67285 25.6026 10.6134 28.0758 12.506 29.9568L15.1998 32.6507L28.518 45.9805L41.8362 32.6507L44.53 29.9568C46.4111 28.0758 47.3632 25.591 47.3632 23.1294C47.3632 20.6562 46.4227 18.1829 44.53 16.3019L44.1933 16.6386L43.8566 16.9754C45.5519 18.6706 46.3995 20.9 46.4111 23.1294C46.4111 25.3587 45.5635 27.5881 43.8566 29.2834L41.1628 31.9772L28.518 44.6219L15.8733 31.9772L13.1795 29.2834C11.4842 27.5765 10.6366 25.3587 10.625 23.1294C10.625 20.9 11.4726 18.6706 13.1795 16.9754C14.8747 15.2801 17.1041 14.4209 19.3334 14.4209C21.5628 14.4209 23.7922 15.2685 25.4875 16.9754L28.518 20.0059L31.5486 16.9754C33.2438 15.2801 35.4732 14.4209 37.7026 14.4209C39.932 14.4209 42.1613 15.2685 43.8566 16.9754L44.1933 16.6386H44.1701Z",
    fill: "#9C5B23"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }